module.exports = __webpack_public_path__ + "img/public/AdminIcons/siteSettingIcon.svg?f31e0ac1";